import DixaIcon from '@dixa/dixa-modern-icons';
import { Checkbox } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import without from 'lodash/without';
import { PureComponent } from 'react';
import { change, WrappedFieldProps as WrappedFieldPropsT } from 'redux-form';

import styles from './categorizedMultiSelectCategoryItem.module.scss';
import type { FieldCategorizedMultiSelectCategoryValuesItemT } from './fieldCategorizedMultiSelect';

type PropsT = {
  item: FieldCategorizedMultiSelectCategoryValuesItemT;
  disabled: boolean;
  readOnly: boolean;
} & WrappedFieldPropsT;

export class CategorizedMultiSelectCategoryItem extends PureComponent<PropsT> {
  isChecked() {
    return this.props.input.value.indexOf(this.props.item.value) !== -1;
  }

  @boundMethod
  selectItem() {
    const { meta, input, readOnly } = this.props;
    if (readOnly) return;
    const { form: formName, dispatch } = meta;
    const { name, value } = input;

    const shouldUncheck = this.isChecked();
    const newValue = shouldUncheck
      ? without(value, this.props.item.value)
      : value.concat([this.props.item.value]);

    dispatch(change(formName, name, newValue));
  }

  render() {
    const { item, disabled, readOnly } = this.props;

    const isChecked = this.isChecked();

    const rootClass = classnames({
      [styles.root]: styles.root,
      [styles.rootDisabled]: disabled,
      [styles.rootReadOnly]: readOnly,
      [styles.rootChecked]: isChecked,
    });

    return (
      <label key={item.name} className={rootClass} htmlFor={item.name}>
        <Checkbox
          checked={isChecked}
          name={item.name}
          id={item.name}
          onChange={this.selectItem}
          className={styles.checkbox}
          disabled={disabled}
        />
        <div className={styles.icon}>
          <DixaIcon icon={item.icon} />
        </div>
        <div className={styles.name}>{item.name}</div>
      </label>
    );
  }
}
